import { getSingleAgentDeliveryIdentifier } from '../operator/getSingleAgentDeliveryIdentifier';
import { getAllVisitorDeliveryIdentifiers } from '../operator/getAllVisitorDeliveryIdentifiers';
import { useThreadDeliveryIdentifierData } from './useThreadDeliveryIdentifierData';
import { useMemo } from 'react';
export const useAgentVisitorDeliveryIdentifiers = ({
  threadId,
  genericChannelId
}) => {
  const {
    loading,
    error,
    threadDeliveryIdentifierData
  } = useThreadDeliveryIdentifierData({
    threadId
  });
  const threadDeliveryIdentifierDataInChannel = threadDeliveryIdentifierData ? threadDeliveryIdentifierData[genericChannelId] : undefined;
  const threadAgentDeliveryIdentifierData = threadDeliveryIdentifierDataInChannel ? getSingleAgentDeliveryIdentifier(threadDeliveryIdentifierDataInChannel) : undefined;
  const threadVisitorDeliveryIdentifiersData = useMemo(() => threadDeliveryIdentifierDataInChannel ? getAllVisitorDeliveryIdentifiers(threadDeliveryIdentifierDataInChannel) : [], [threadDeliveryIdentifierDataInChannel]);
  return {
    loading,
    error,
    threadAgentDeliveryIdentifierData,
    threadVisitorDeliveryIdentifiersData
  };
};